<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<div class="container-fluid bg-img-v4 py-5">
<div class="container custom-bg-1">
    <app-signup-form [type]="'CREATE'"></app-signup-form>
</div>
</div>
<app-footer></app-footer>